import React, {useState} from "react";
import {MemoryRouter, Route, useHistory} from 'react-router-dom'


import {setPathForRouter} from "@common-helpers/set-rout-path"
import {CSSTransition} from 'react-transition-group'

import {useInit} from "@common-helpers/init-answers-state"
import {initStickyElements} from "@common-helpers/init-sticky-element"
import {componentMount} from "@common-hooks/component-mount"

import {Logo} from '@common-layout-components/logo'

import {MainPage} from "./index/index"
import {AboutFitness} from "@common-questionnaire-pages/about-fitness"
import {RadioQuestion} from "@common-questionnaire-pages/radio-question"


import {RadioQuestionWithIllustration} from "@common-questionnaire-body-plan-pages/radio-question-with-illustration"
import CheckboxQuestionSimple from "@common-questionnaire-body-plan-pages/checkbox-question-simple"
import {CheckboxQuestionWithIllustration} from "@common-questionnaire-body-plan-pages/checkbox-question-with-illustration"

import {BodyType} from "@common-questionnaire-body-plan-pages/body-type"
import {InputQuestion} from "@common-questionnaire-body-plan-pages/input-question"
import AnswersHandling from "@common-questionnaire-body-plan-pages/answers-handling"
import RadioQuestionSimple from "@common-questionnaire-body-plan-pages/radio-question-simple"


import {RadioQuestionNumber} from "@common-questionnaire-pages/radio-question-number"
import {LinkQuestion} from "@common-questionnaire-pages/link-question"

import {Registration} from './registration'
import {ChoicePrice} from '@common-questionnaire-body-plan-pages/choice-price'
import {PlanForLoseWeight} from '@common-questionnaire-body-plan-pages/plan-for-lose-weight'
import {CardPay} from './card-pay'

import {CheckboxQuestion} from "@common-questionnaire-pages/checkbox-question"
import {BeforeAfterWithProgressBar} from "@common-questionnaire-pages/before-after-with-progress-bar"
import {IllustratedProgress} from "@common-questionnaire-pages/illustrated-progress"
import {WaterWithProgressBar} from "@common-questionnaire-pages/water-with-progress-bar"
import {AboutYou} from "@common-questionnaire-pages/about-you"
import {AnalysisData} from "@common-questionnaire-pages/analysis-data"
import {Creators} from "@common-questionnaire-pages/creators"
import {IconCheckboxQuestion} from "@common-questionnaire-pages/icon-checkbox-question"
import {ConsultDoctor} from "@common-questionnaire-pages/consult-doctor"
import {WeightChart} from "@common-questionnaire-pages/weight-chart"
import {WhenBirthday} from "@common-questionnaire-pages/when-birthday"

import {Geography} from "@common-questionnaire-pages/geography"
import {Doctors} from "@common-questionnaire-pages/doctors"
import {DietLimiter} from "@common-questionnaire-pages/diet-limiter"

import {Start} from "@common-pay-pages/start-with-tariff"
import {Done} from "@common-pay-pages/done"

import {StepProgressBarLine, useStepProgressBar} from 'react-step-progress-bar-line'

import '@common-style/index.scss'
import '@common-body-plan-styles/style.scss'


import './style.scss'


import {componentsProps} from './components-options'
import {HealthConsultations} from "@common-questionnaire-pages/health-consultations";

import HandlingBg from '@common-images/my-body-plan-bg.png'

import Book from "@common-images/book-animation.gif";


export function importAllImages(r) {
    let images = {}
    r.keys().map((item, index) => {
        images[item.replace('./', '').replace(/\.(png|jpe?g|svg)$/, '')] = r(item).default
    })
    return images
}

const images = importAllImages(require.context('./radio-images', false, /\.(png|jpe?g|svg)$/))

const LandingPages = ({nextStep, getPath, shouldChangeUrl = false}) => {


    const progressPagesCount = 15

    let currentRoutName = window.location.href.split('/')[window.location.href.split('/').length - 1],
        progressBarRouts = [
            {pathname: getPath('/sex')},
            {pathname: getPath('/body-type')},
            {pathname: getPath('/activity')},

            {pathname: getPath('/bad-habits')},
            {pathname: getPath('/physical-activity')},
            {pathname: getPath('/well-being')},
            {pathname: getPath('/has-discomfort')},
            {pathname: getPath('/sleep-time')},
            {pathname: getPath('/water-drink')},
            {pathname: getPath('/cook-time')},
            {pathname: getPath('/choose-vegetables')},
            {pathname: getPath('/favorite-products')},


            {pathname: getPath('/height')},
            {pathname: getPath('/weight')},
            {pathname: getPath('/need-weight')},
        ],
        activeProgressBarStep = 1

        progressBarRouts.forEach((item, index) => {

            if (item.pathname === getPath(`/${currentRoutName}`)) activeProgressBarStep = index + 1

        })

        const [activeStep, sections, setNextProgressBarStep, setPrevProgressBarStep] = useStepProgressBar({
            activeStep: activeProgressBarStep,
            sections: [
                {
                    stepsCount: progressPagesCount
                }
            ],
            stepChangeCallback: (step) => {


                localStorage.setItem('main-progress-step', String(step))

                return true
            },
            finishCallback: () => {
                // alert('finish');

                return true
            }
        }),
        progressBarRouterList = progressBarRouts.map(({ pathname }, routIndex) => {


                return (<Route key={pathname} exact path={pathname}>
                    {({ match }) => (
                        <CSSTransition
                            in={match != null}
                            timeout={0}
                            classNames={{
                                enter: 'fadeIn hidden',
                                enterActive: 'fadeIn',
                                enterDone: 'fadeIn',
                                exit: 'fadeOut'
                            }}
                            onEntered={initStickyElements}
                            unmountOnExit
                        >
                            <div className={'step-progress-bar-line-wrapper'}>
                                <Logo />
                                <StepProgressBarLine activeStep={activeStep} sections={sections} />
                            </div>

                        </CSSTransition>
                    )}
                </Route>)
            }
        )

    const routes = [
                {pathname: getPath('/'), name: 'Index', Component: MainPage},
                {pathname: getPath('/sex'), name: 'Sex', Component: RadioQuestionWithIllustration, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/body-type'), name: 'BodyType', Component: BodyType, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/activity'), name: 'Activity', Component: RadioQuestionWithIllustration, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},

                {pathname: getPath('/bad-habits'), name: 'BadHabits', Component: CheckboxQuestionSimple, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/physical-activity'), name: 'PhysicalActivity', Component: RadioQuestionSimple, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/well-being'), name: 'WellBeing', Component: RadioQuestionSimple, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/has-discomfort'), name: 'HasDiscomfort', Component: RadioQuestionSimple, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/sleep-time'), name: 'SleepTime', Component: RadioQuestionSimple, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/water-drink'), name: 'WaterDrink', Component: RadioQuestionSimple, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/cook-time'), name: 'CookTime', Component: RadioQuestionSimple, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/choose-vegetables'), name: 'ChooseVegetables', Component: CheckboxQuestionWithIllustration, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/favorite-products'), name: 'FavoriteProducts', Component: CheckboxQuestionWithIllustration, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},



                {pathname: getPath('/height'), name: 'Height', Component: InputQuestion, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/weight'), name: 'Weight', Component: InputQuestion, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/need-weight'), name: 'NeededWeight', Component: InputQuestion, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},
                {pathname: getPath('/answer-handling'), name: 'AnswersHandling', Component: AnswersHandling, nextCallback: setNextProgressBarStep, prevCallback: setPrevProgressBarStep},

                { pathname: getPath('/mail'), name: 'Registration', Component: Registration},
                { pathname: getPath('/card-pay'), name: 'CardPay', Component: CardPay}
    ]
    let activeRouteName = '',
        [activeRouteNameState, setActiveRouteNameState] = useState(null)

    routes.forEach((item, index) => {
        if (item.pathname === getPath(`/${currentRoutName}`)) activeRouteName = item.name
    })

    const [answersOnQuestions, setAnswersOnQuestions] = useInit(routes),
        routesList = routes.map((componentSettings, routIndex) => {

                const {pathname, name: componentName, Component} = componentSettings,
                      componentProps = componentsProps[componentName] || {},
                      nextPageId = routIndex + 2,
                      prevPageId = routIndex,
                      nextRoutIndex = routIndex + 1,
                      prevRoutIndex = routIndex - 1,
                      nextRout = routes[nextRoutIndex] ? routes[nextRoutIndex].pathname : null,
                      prevRout = routes[prevRoutIndex] ? routes[prevRoutIndex].pathname : null

                return (<Route key={pathname} exact path={pathname}>
                    {({match}) => (
                        <CSSTransition
                            in={match != null}
                            timeout={0}
                            classNames={{
                                enter: 'hidden',
                                enterActive: 'hidden',
                                enterDone: '',
                                exit: 'componentExit'
                            }}
                            onEntered={() => {
                                document.querySelector('.component-scroll-wrapper').scrollTo(0, 0)
                                setActiveRouteNameState(componentName)
                                initStickyElements()
                            }}
                            unmountOnExit
                        >
                            <Component {...{
                                ...componentSettings,
                                ...componentProps,
                                routes,
                                nextRout,
                                prevRout,
                                componentName,
                                answersOnQuestions,
                                setAnswersOnQuestions,
                                nextStep,
                                getPath,
                                nextPageId,
                                prevPageId,
                                setNextProgressBarStep,
                                setPrevProgressBarStep,
                                activeProgressBarStep,
                                progressPagesCount
                            }} />
                        </CSSTransition>
                    )}
                </Route>)
            }
        ),
        history = useHistory()


        componentMount(() => {
            initStickyElements()

            setTimeout(() => {

                const handlingBg = new Image();
                handlingBg.src=HandlingBg;

                const book = new Image();
                book.src=Book;


                for (let img in images) {
                    let imgPath = images[img]

                    console.log(imgPath);

                    new Image().src=imgPath;
                }

            },0);



        });

    return (<div className={`component-scroll-wrapper ${activeRouteNameState || activeRouteName}Page`} >

        {shouldChangeUrl ? routesList : <MemoryRouter initialEntries={[...routes]}>{routesList}</MemoryRouter>}
        {progressBarRouterList}
    </div>)

}

export default LandingPages
